import { Visibility, VisibilityOff } from '@material-ui/icons';
import React, { FC } from 'react';
import styled from 'styled-components';

type Props = {
  allowVisibility: boolean;
};
const DetailsIcon: FC<Props> = ({ allowVisibility }) => {
  return (
    <DetailsWrapper>
      {allowVisibility ? (
        <IconButton title="View details">
          <Visibility />
        </IconButton>
      ) : (
        <DisabledIcon title="Not available yet">
          <VisibilityOff />
        </DisabledIcon>
      )}
    </DetailsWrapper>
  );
};

export default DetailsIcon;

const DetailsWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  @media only screen and (max-width: 840px) {
    position: absolute;
    right: 12px;
    top: 12px;
  }
`;

const IconButton = styled.div`
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: var(--neutral-500);
  background: transparent;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;

  svg {
    font-size: 18px;
  }

  &:hover {
    color: var(--primary-600);
    background: var(--primary-50);
  }
`;

const DisabledIcon = styled.div`
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: var(--neutral-300);
  cursor: not-allowed;

  svg {
    font-size: 18px;
  }
`;
